/**
 * PHA-851: the EDIT target the Voice-of-the-Patient wizard (PcmIntakeReviewPanel) is seeded
 * from — the goal plus its GAS scale and its own barriers. Shared by the patient chart's
 * "Voice of the patient" tab and the care-plan approval step (PHA-1162).
 */
export const buildVopGoalEditTarget = (
  goal: any,
  gasDefinitions: readonly any[] | null | undefined,
  barriers: readonly any[] | null | undefined,
  goalCount: number,
) => {
  const gas = (gasDefinitions ?? []).find((d: any) => d.pco_ref === goal.pco_ref);
  // Link by pco_ref; for legacy single-goal data (barriers not yet linked) attach all.
  const goalBarriers = (barriers ?? []).filter(
    (b: any) => b.pco_ref === goal.pco_ref || (b.pco_ref == null && goalCount === 1)
  );
  return {
    pco_ref: goal.pco_ref,
    goal_text: goal.goal_text,
    tracking_question: goal.tracking_question ?? '',
    sort_order: goal.sort_order ?? 0,
    gas: gas
      ? {
          level_minus2: gas.level_minus2,
          level_minus1: gas.level_minus1,
          level_zero: gas.level_zero,
          level_plus1: gas.level_plus1,
          level_plus2: gas.level_plus2,
          baseline_level: gas.baseline_level,
          baseline_effective_date: gas.baseline_effective_date,
        }
      : undefined,
    barriers: goalBarriers.map((b: any) => ({
      barrier_ref: b.barrier_ref,
      barrier_category: b.barrier_category,
      barrier_text: b.barrier_text,
      sort_order: b.sort_order,
    })),
  };
};

/** PHA-1162: user-facing reason a PCMH clinic's care plan cannot be approved yet. */
export const VOICE_OF_PATIENT_REQUIRED_MESSAGE =
  'Voice of the Patient is required for PCMH clinics — add at least one patient goal before approving the care plan.';
